import React from "react";
import { useNavigate } from "react-router-dom";

const steps = [
  { key: "moviebooking", label: "Movie Booking" },
  { key: "details", label: "Movie Details" },
  { key: "seats", label: "Select Seats" },
  { key: "confirm", label: "Confirm Ticket" }
];

const BookingBreadcrumb = ({ currentStep, showBack = true, fallback = "/moviebooking", onBack = null }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (typeof onBack === "function") {
      onBack();
      return;
    }
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate(fallback, { replace: true });
    }
  };

  const currentIndex = steps.findIndex(step => step.key === currentStep);
  const visibleSteps = currentIndex >= 0 ? steps.slice(0, currentIndex + 1) : steps;

  return (
    <div className="bg-white border border-gray-200 rounded-md px-4 py-2 mb-4 flex items-center gap-3 flex-wrap">
      {showBack && (
        <button
          type="button"
          onClick={handleBack}
          className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-50"
        >
          Back
        </button>
      )}
      <div className="text-sm text-gray-600 flex items-center gap-2 flex-wrap">
        {visibleSteps.map((step, idx) => (
          <React.Fragment key={step.key}>
            <span className={step.key === currentStep ? "font-semibold text-gray-900" : ""}>
              {step.label}
            </span>
            {idx < visibleSteps.length - 1 && <span className="text-gray-300">/</span>}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default BookingBreadcrumb;
